<template>
  <b-row>
    <!-- Nombre de projets -->
    <b-col lg="3" sm="6">
      <b-card>
        <b-card-body class="d-flex justify-content-between align-items-center">
          <div>
            <h5 class="mb-0">{{ stats.total_bids }}</h5>
            <span class="font-weight-bold text-muted font-small-3">Offres</span>
          </div>
          <div class="avatar bg-light-primary p-50">
            <div class="avatar-content">
              <feather-icon icon="BriefcaseIcon" size="18" />
            </div>
          </div>
        </b-card-body>
      </b-card>
    </b-col>

    <!-- Projets actifs -->
    <b-col lg="3" sm="6">
      <b-card>
        <b-card-body class="d-flex justify-content-between align-items-center">
          <div>
            <h5 class="mb-0">{{ stats.active_projects }}</h5>
            <span class="font-weight-bold text-muted font-small-3">Projets actifs</span>
          </div>
          <div class="avatar bg-light-success p-50">
            <div class="avatar-content">
              <feather-icon icon="CheckCircleIcon" size="18" />
            </div>
          </div>
        </b-card-body>
      </b-card>
    </b-col>

    <!-- Revenu total -->
    <b-col lg="3" sm="6">
      <b-card>
        <b-card-body class="d-flex justify-content-between align-items-center">
          <div>
            <h6 class="mb-0">{{ amountToCurrency(stats.total_revenue) }}</h6>
            <span class="font-weight-bold text-muted font-small-3">Revenu total</span>
          </div>
          <div class="avatar bg-light-info p-50">
            <div class="avatar-content">
              <feather-icon icon="DollarSignIcon" size="18" />
            </div>
          </div>
        </b-card-body>
      </b-card>
    </b-col>

    <!-- Paiements en attente -->
    <b-col lg="3" sm="6">
      <b-card>
        <b-card-body class="d-flex justify-content-between align-items-center">
          <div>
            <h6 class="mb-0">{{ amountToCurrency(stats.pending_payments) }}</h6>
            <span class="font-weight-bold text-muted font-small-3">Paiements en attente</span>
          </div>
          <div :class="`avatar ${stats.pending_payments > 0 ? 'bg-light-warning' : 'bg-light-success'} p-50`">
            <div class="avatar-content">
              <feather-icon :icon="stats.pending_payments > 0 ? 'AlertCircleIcon' : 'CheckIcon'" size="18" />
            </div>
          </div>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {BCard, BCardBody, BCol, BRow} from "bootstrap-vue";
import {amountToCurrency} from "@/utils/formatAmount";

export default {
  name: 'ClientsViewClientStatsCards',
  methods: {amountToCurrency},
  components: {BCardBody, BCard, BCol, BRow},
  props: {
    stats: {
      type: Object,
      required: true,
    },
  },
}
</script>